export class TableType {
  static readonly StandardTable = 'StandardTable';
  static readonly TransposedTable = 'TransposedTable';
  static readonly TrialBalanceStandard = 'TrialBalanceStandard';
  static readonly TrialBalanceSingleEntity = 'TrialBalanceSingleEntity';
  static readonly TrialBalanceMultipleEntities = 'TrialBalanceMultipleEntities';
  static readonly Transaction = 'Transaction';
  static readonly Matrix = 'Matrix';
}
